import { gql } from '@apollo/client';

export const GET_SUBSCRIPTION_FEATURE_TOGGLES = gql`
  query getSubscriptionFeatureToggles {
    app {
      id
      autoRenewReminderPopupEnabled
      sandboxSubscriptionSkuCheatEnabled
      sandboxSubscriptionSkuCheatUserIds
      economicTransactionReceiptLogEnabled
      unblockFriendEnabled
      fullRefundToggles {
        purchaseType
        enabled
      }
    }
  }
`;

export const UPDATE_SUBSCRIPTION_FEATURE_TOGGLES = gql`
  mutation updateSubscriptionFeatureToggles(
    $autoRenewReminderPopupEnabled: Boolean
    $sandboxSubscriptionSkuCheatEnabled: Boolean
    $sandboxSubscriptionSkuCheatUserIds: [String!]
    $economicTransactionReceiptLogEnabled: Boolean
    $unblockFriendEnabled: Boolean
    $fullRefundToggles: [FullRefundToggleInput!]
  ) {
    updateAppFeatureToggles(
      input: {
        autoRenewReminderPopupEnabled: $autoRenewReminderPopupEnabled
        sandboxSubscriptionSkuCheatEnabled: $sandboxSubscriptionSkuCheatEnabled
        sandboxSubscriptionSkuCheatUserIds: $sandboxSubscriptionSkuCheatUserIds
        economicTransactionReceiptLogEnabled: $economicTransactionReceiptLogEnabled
        unblockFriendEnabled: $unblockFriendEnabled
        fullRefundToggles: $fullRefundToggles
      }
    ) {
      autoRenewReminderPopupEnabled
      sandboxSubscriptionSkuCheatEnabled
      sandboxSubscriptionSkuCheatUserIds
      economicTransactionReceiptLogEnabled
      unblockFriendEnabled
      fullRefundToggles {
        purchaseType
        enabled
      }
    }
  }
`;
